export default "__VITE_ASSET__BKGjJfpZ__"